import { useEffect, useState } from 'react';

// Tela de celular (03/11/2026): até 768px de largura.
export const MOBILE_QUERY = '(max-width: 768px)';

const casa = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;

export default function useIsMobile() {
  const [mobile, setMobile] = useState(casa);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(MOBILE_QUERY);
    const mudou = () => setMobile(mq.matches);
    mudou();
    // 'change' cobre girar o celular; 'resize' cobre quem não dispara o
    // 'change' ao mudar a largura (alguns emuladores de dispositivo).
    mq.addEventListener ? mq.addEventListener('change', mudou) : mq.addListener(mudou);
    window.addEventListener('resize', mudou);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', mudou) : mq.removeListener(mudou);
      window.removeEventListener('resize', mudou);
    };
  }, []);
  return mobile;
}
